import { RouteAccess, type RouteConfigOption } from '@lingoda/router';
import { assertExhaustedSwitch } from '@lingoda/utils';
import { PrivatePageFrame } from './PrivateFrame';
import { PublicPageFrame } from './PublicFrame';
import type { PropsWithChildren } from 'react';

const Frame = (props: PropsWithChildren<RouteConfigOption>) => {
    const { access = RouteAccess.Private } = props;

    switch (access) {
        case RouteAccess.All:
            return <>{props.children}</>;
        case RouteAccess.Public:
            return <PublicPageFrame {...props} />;
        case RouteAccess.Private:
            return <PrivatePageFrame {...props} />;
        default:
            assertExhaustedSwitch(access);
            throw new Error(`Student Frame: Unhandled access type: ${access}`);
    }
};

export default Frame;
